import type { JSX } from 'react';
import { Link } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';

export function ForbiddenNotice({ homeTo = '/' }: { homeTo?: string }): JSX.Element {
  return (
    <div className="card flex flex-col items-center gap-3 p-10 text-center">
      <ShieldAlert className="h-10 w-10 text-muted-foreground" />
      <h2 className="text-lg font-semibold text-heading">Nincs jogosultságod ehhez a funkcióhoz</h2>
      <Link to={homeTo} className="text-sm font-medium text-echo-gold hover:underline">
        Vissza a kezdőoldalra
      </Link>
    </div>
  );
}
